import { getProductFlowConfiguration } from '@flows/configs/shared/flowConfiguration'
import type { FlowConfigProps, StepConfigParams } from '@flows/configs/types'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'
import * as flowConfigUtils from '@flows/insurance/utils'

import { schema } from './schema'
import getSteps from './steps'

const getDroneConfig = ({ clientHelpers, subFlow = SubFlow.LiabilityNxt }: FlowConfigProps) => {
  const productKey = 'liability_v1_getsafe_de'

  const droneStepParams = {
    productKey,
    clientHelpers,
    helperFunctions: flowConfigUtils.generateGetFlowValueFunctions(productKey),
    subFlow,
  } satisfies StepConfigParams
  const steps = getSteps(droneStepParams)
  const FIRST_STEP_NAME = 'number_of_drones'

  return getProductFlowConfiguration(productKey, steps, {
    constants: {
      FIRST_STEP_NAME,
      SCHEMA: schema,
    },
    getInitialValues: () => {
      return {
        [productKey]: {
          productKey,
          configuration_parameters: {
            tariff_line: 'premium',
            drones_coverage: true,
            family_coverage: false,
          },
        },
      }
    },
  })
}

export default getDroneConfig
